import { graphServiceConfig } from "../config/authConfig";

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken 
 */
export namespace AuthService {
	export async function getGraphProfile(accessToken: string) {
		const headers = new Headers();
		const bearer = `Bearer ${accessToken}`;

		headers.append("Authorization", bearer);

		const options = {
			method: "GET",
			headers: headers
		};

		return fetch(graphServiceConfig.graphMeEndpoint, options)
			.then(response => response.json())
			.catch(error => console.log(error));
	}
}
